import { FormattedMessage } from 'react-intl'

import { PromoDealsList } from './promo-deals-list'
import { PromoOffersHeader } from './promo-offers-header'
import { PromoOffersTips } from './promo-offers-tips'
import { PromoRoomAndDealsBanner } from './promo-room-and-deals-banner'

export const PromoOffersSection = () => {
  return (
    <section className="flex flex-col gap-8">
      <PromoOffersHeader />
      <PromoOffersTips items={tips} />
      <PromoDealsList />
      <PromoRoomAndDealsBanner />
    </section>
  )
}

const tips = [
  <FormattedMessage
    key="promo.offers.tip.0"
    id="promo.offers.tip.0"
  />,
  <FormattedMessage
    key="promo.offers.tip.1"
    id="promo.offers.tip.1"
  />,
  <FormattedMessage
    key="promo.offers.tip.2"
    id="promo.offers.tip.2"
  />,
]
